module.exports = __webpack_public_path__ + "static/p1-35cde358fad212d78c9de32cfe67a3e9.jpg";